import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import {} from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './aidas-properties.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const AidasPropertiesDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const aidasPropertiesEntity = useAppSelector(state => state.aidasProperties.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="aidasPropertiesDetailsHeading">AidasProperties</h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">ID</span>
          </dt>
          <dd>{aidasPropertiesEntity.id}</dd>
          <dt>
            <span id="name">Name</span>
          </dt>
          <dd>{aidasPropertiesEntity.name}</dd>
          <dt>
            <span id="value">Value</span>
          </dt>
          <dd>{aidasPropertiesEntity.value}</dd>
          <dt>
            <span id="systemProperty">System Property</span>
          </dt>
          <dd>{aidasPropertiesEntity.systemProperty ? 'true' : 'false'}</dd>
          <dt>
            <span id="optional">Optional</span>
          </dt>
          <dd>{aidasPropertiesEntity.optional ? 'true' : 'false'}</dd>
          <dt>
            <span id="description">Description</span>
          </dt>
          <dd>{aidasPropertiesEntity.description}</dd>
        </dl>
        <Button tag={Link} to="/aidas-properties" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" /> <span className="d-none d-md-inline">Back</span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/aidas-properties/${aidasPropertiesEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" /> <span className="d-none d-md-inline">Edit</span>
        </Button>
      </Col>
    </Row>
  );
};

export default AidasPropertiesDetail;
